import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { AgencyPeopleIcon } from '@fiverr-private/icons';
import I18nProviderWrapper from '../../I18nProvider';
import './index.scss';

const AgenciesBanner = ({ isWide, isPro, onClick, onBannerHover, onButtonHover, url, descriptionKey, i18n }) => (
    <div onMouseEnter={onBannerHover} className={classnames('agencies-menu-banner', { 'is-wide': isWide }, { 'is-pro': isPro })}>
        <div className="container flex flex-row flex-items-center flex-justify-between">
            <div className="flex flex-row">
                {isWide && <div className="flex flex-center p-r-20"><AgencyPeopleIcon size={32}/></div>}
                <div>
                    <h3 className="tbody-4 co-text-darkest">
                        {i18n.t('categories_menu.agencies_banner.title')}
                    </h3>
                    <p className="tbody-5 co-text-darkest p-t-4">
                        {i18n.t(`categories_menu.agencies_banner.description.${descriptionKey}`) }
                    </p>
                </div>
            </div>
            <Button onMouseEnter={onButtonHover} href={url} onClick={onClick} className="agencies-banner-cta m-l-20" color="black" size="small" fill="ghost">
                {i18n.t('categories_menu.agencies_banner.cta')}
            </Button>
        </div>
    </div>
);

AgenciesBanner.propTypes = {
    isPro: PropTypes.bool,
    isWide: PropTypes.bool,
    onClick: PropTypes.func,
    onBannerHover: PropTypes.func,
    onButtonHover: PropTypes.func,
    url: PropTypes.string,
    descriptionKey: PropTypes.string,
    i18n: PropTypes.object
};

export default I18nProviderWrapper(AgenciesBanner);
export { AgenciesBanner };
